export function Section({ children, className = '', title='' }) {
    return <div className={`${className}`}>
        {title && <h3 className="ml-2">{title}</h3>}
        {children}
    </div>
}